export const gtag = (...args: unknown[]) => {
  return () => window.gtag(args)
}
